<div class="success">
    <h1>Thank You</h1>
    <p>Your Request has been submitted Successfully</p>
        <a class="btn button" href="https://dev.ateccotechnologies.com/wordpress/"><i class="icon-home"></i> Go to Site</a>
</div>
